import React, { useEffect } from "react";
import { TOptionValue } from "../../optionsUtils";

import "./Toggle.scss";

interface IProps {
    value?: TOptionValue;
    onClick?: (e) => void;
    disabled?: boolean;
}

export default function Toggle(props: IProps) {
    const [value, setValue] = React.useState<TOptionValue | string>(props.value || "unselected");

    const onClick = (e) => {
        if (props.disabled) {
            return;
        }

        if (props.onClick) {
            props.onClick(e);

            return;
        }

        if (value === "selected") {
            setValue("unselected");
        } else if (value === "unselected") {
            setValue("selected");
        } else {
            setValue("indeterminate");
        }
    };

    useEffect(() => {
        if (props.value) {
            setValue(props.value);
        }
    }, [props.value]);

    return (
        <button
            disabled={props.disabled}
            onClick={onClick}
            type="button"
            className={`userful-toggle ${
                value === "selected"
                    ? "userful-toggle-selected"
                    : value === "indeterminate"
                      ? "userful-toggle-indeterminate"
                      : ""
            }`}
        >
            <div className="userful-toggle-element"></div>
        </button>
    );
}
